import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from './../layouts'
import Login from './../views/login'
import home from './../views/login'
Vue.use(VueRouter)
const routes = [{
        path: '/login',
        name: 'login',
        component: Login,
        props() {
            return { path: 'login' }
        }
    },
    {
        path: '/',
        name: 'home',
        component: home,
        props() {
            return { path: 'home' }
        }
    },
    {
        path: '/loc',
        name: 'loc',
        component: null,
        meta: {
            localaccess: true
        },
        props() {
            return { path: 'pub' }
        }
    },
    {
        path: '/pub',
        name: 'pub',
        component: null,
        meta: {
            publicaccess: true
        },
        props() {
            return { path: 'pub' }
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Login,
        props() {
            return { path: 'register' }
        }
    },
    {
        path: '/admin',
        name: '',
        component: Layout,
        meta: {
            requireslicence: true
        },
        props() {
            return { type: 'dash' }
        },
        children: [{
                path: '/',
                component: () =>
                    import ('./../components/Cards/admin/dashbored/dashbored.vue'),
                name: 'home'
            },
            {
                path: '/manage/bank',
                component: () =>
                    import ('./../components/Cards/admin/Bank/bank.vue'),
                name: 'home'
            },
            {
                path: '/manage/tf',
                component: () =>
                    import ('./../components/Cards/admin/transactionfee/expense.vue'),
                name: 'tf'
            },
            {
                path: '/manage/transaction',
                component: () =>
                    import ('./../components/Cards/admin/transactions/expense.vue'),
                name: 'transaction'
            },
            {
                path: '/create/transaction',
                component: () =>
                    import ('./../components/Cards/admin/transactions/transaction.vue'),
                name: 'transaction'
            },
            {
                path: '/transactions',
                component: () =>
                    import ('./../components/Cards/admin/transactions/expenseadmin.vue'),
                name: 'transaction'
            },
            {
                path: '/manage/users',
                component: () =>
                    import ('./../components/Cards/admin/Users/AllUsers.vue'),
                name: 'All Users'
            },
            
            {
                path: '/account/and/profile',
                component: () =>
                    import ('./../components/Cards/admin/AcountAndProfile/acount.vue'),
                name: 'profile'
            },{
                path: '/rate',
                component: () =>
                    import ('./../components/Cards/admin/expense/expense.vue'),
                name: 'profile'
            },{
                path: '/country',
                component: () =>
                    import ('./../components/Cards/admin/country/expense.vue'),
                name: 'profile'
            }
         ]
    },
]

const router = new VueRouter({
    routes
    // mode: 'history'
})

export default router